import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  const isWebKit =
    /AppleWebKit/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

  useEffect(() => {
    if (document.visibilityState !== 'visible') return;

    if (isWebKit) {
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTop#value

      // ensure we're not in an over-scrolled state
      if (document.documentElement.scrollTop < 0 || document.body.scrollTop < 0) {
        // reset any negative scroll position
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }

      const htmlStyle = document.documentElement.style;
      const originalOverscrollBehavior = htmlStyle.overscrollBehavior;

      htmlStyle.overscrollBehavior = 'none';
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });

      setTimeout(() => {
        htmlStyle.overscrollBehavior = originalOverscrollBehavior;
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }
  }, [pathname, isWebKit]);

  return null;
};
